import React from "react";

function CompletePieIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="40"
      fill="none"
      viewBox="0 0 74 40"
    >
      <path fill="#B7B3B2" d="M8.957 26.144H64.654V27.281H8.957z"></path>
      <path
        stroke="#ACA9A7"
        strokeLinejoin="round"
        d="M9.275 9.693V33.7h55.697V9.693m-55.697 0v10.492m0-10.492h55.697m0 0v10.492M8.638 38.934h56.334c4.219 0 7.639 1.05 7.639-5.235H1c0 6.286 3.42 5.235 7.638 5.235z"
      ></path>
      <circle cx="36.806" cy="4.914" r="4.414" stroke="#ACA9A7"></circle>
    </svg>
  );
}

export default CompletePieIcon;
